import styled from 'styled-components';
import { OptionsSelectStyled } from '../OptionsSelectStyled';
import { rem } from 'polished';

export const OptionsSelectStyledAC = styled(OptionsSelectStyled)`
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey25};
    padding-bottom: ${rem(10)};
    margin-bottom: ${rem(30)};

    .Collapsible__trigger {
        font-size: ${({ theme }) => theme.fontSizes.h6};
        &:after {
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='6' viewBox='0 0 26 14' fill='none'%3E %3Cpath d='M1 13L13 1L25 13' stroke='red' stroke-width='3' stroke-linejoin='bevel'/%3E %3C/svg%3E");
        }

        button {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            color: ${({ theme }) => theme.colors.grey5};
        }
    }

    .selectedOptions {
        font-size: ${({ theme }) => theme.fontSizes.textTiny};
        background: ${({ theme }) => theme.colors.red};
    }
`;
